import React from 'react'

const Loading = () => {
  return (
    <div className='section secton-center loading-frame'>
      <div className='loading'></div>
    </div>
  )
}

export default Loading
